// Mientras llega el chunk de la home: el mismo primer pintado que index.html (#hero-fp, estilos allí),
// así no hay pantallazo en blanco entre el HTML y el hero animado.
export default function HomeFirstPaint() {
  return <div id="hero-fp" aria-hidden="true" />;
}
